(function () {

 'use strict';

   angular.module('eclipseApp.core').filter('accountNumberFilter', function() {
          return function(text){
          if(text){
            var accountNumber = text.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, "").replace(/-|\s/g,"").replace(/[\. ,:-]+/g, "");
            return accountNumber;
          }
          }

   });


 })();



